var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 0H2.33333C1.05 0 0.0116669 1.0125 0.0116669 2.25L0 20.25C0 21.4875 1.03833 22.5 2.32167 22.5H16.3333C17.6167 22.5 18.6667 21.4875 18.6667 20.25V6.75L11.6667 0ZM12.8333 11.25H8.16667V12.375H11.6667C12.3083 12.375 12.8333 12.8813 12.8333 13.5V16.875C12.8333 17.4937 12.3083 18 11.6667 18H10.5V19.125H8.16667V18H5.83333V15.75H10.5V14.625H7C6.35833 14.625 5.83333 14.1187 5.83333 13.5V10.125C5.83333 9.50625 6.35833 9 7 9H8.16667V7.875H10.5V9H12.8333V11.25ZM10.5 6.75V1.6875L15.75 6.75H10.5Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.1d9ab08b76e4829d153c9adbf7329e3c.svg";
export { ForwardRef as ReactComponent };